import { FIELD_NAMES } from "constants/fieldLabels.constants";

import { Scenario, Stick } from "../models/scenario";

export const VERTICAL_OFFSET_PATTERN = /^[BT][+-][0-9]+$/i;

/**
 * Returns true only if every stick has non-zero depth values.
 * A stick has depth when any survey point has a non-zero z coordinate,
 * or when heelDepth / toeDepth is non-zero.
 *
 * Used to detect shapefiles uploaded without Z values so a warning can
 * be surfaced to the user. The warning should fire when ANY stick lacks
 * depth, not only when ALL sticks lack depth.
 */
export function sticksHaveDepth(sticks: Stick[]): boolean {
  if (!sticks || sticks.length === 0) return true;
  return sticks.every(
    (stick) =>
      stick.survey?.some((point) => point.z != null && point.z !== 0) ||
      (stick.heelDepth != null && stick.heelDepth !== 0) ||
      (stick.toeDepth != null && stick.toeDepth !== 0)
  );
}

export const flattenScenarioData = (scenarioData: Scenario[]) => {
  const flatternedData = [];
  scenarioData.forEach((scenario) => {
    if (scenario.layerPlacements?.length) {
      scenario.layerPlacements?.forEach((layerPlacement) => {
        scenario.sticks?.forEach((stick) => {
          if (stick.configurationId === layerPlacement.id) {
            flatternedData.push({
              "Scenario ID": scenario.scenarioId,
              "Pad Name": scenario.padName,
              Play: scenario.play,

              "Layer ID": layerPlacement.id,
              Polygon:
                layerPlacement.polygon?.field + " " + layerPlacement.polygon?.value,
              "Reference Zone": layerPlacement.referenceZone,
              "On Prod Date": layerPlacement.onProdDate,
              Azimuth: layerPlacement.azimuth,
              [FIELD_NAMES.HZ_LENGTH]: layerPlacement.hzLength,
              "Min Heel Offset": layerPlacement.minHeelOffset,
              "Min Toe Offset": layerPlacement.minToeOffset,
              Spacing: layerPlacement.horizontalSpacingBetweenSticks,
              "Left Horizontal Offset": layerPlacement.leftHorizontalOffset,
              "Right Horizontal Offset": layerPlacement.rightHorizontalOffset,
              "Vertical Offset": layerPlacement.verticalOffset,

              "Stick ID": stick.id,
              "Heel Depth": stick.heelDepth,
              "Toe Depth": stick.toeDepth,
              Length: stick.hzLength_m
              // Survey: JSON.stringify(stick.survey)
            });
          }
        });
      });
    } else {
      scenario.sticks?.forEach((stick) => {
        flatternedData.push({
          "Scenario ID": scenario.scenarioId,
          "Pad Name": scenario.padName,
          Play: scenario.play,

          "Stick ID": stick.id,
          "On Prod Date": stick.onProdDate,
          "Heel Depth": stick.heelDepth,
          "Toe Depth": stick.toeDepth,
          Length: stick.hzLength_m
          // Survey: JSON.stringify(stick.survey)
        });
      });
    }
  });

  return flatternedData;
};
